import { useParams } from 'react-router-dom';

import ReviewDetail from '../../features/reviews/layouts/detail';
import ReviewQueue from '../../features/reviews/layouts/queue';

export default function ReviewsPage() {
    const { taskId } = useParams();
    const id = Number(taskId);
    if (taskId) return <ReviewDetail key={id} taskId={Number.isInteger(id) && id > 0 ? id : 0} />;
    return <ReviewQueue />;
}
